import { TicketCategory, TicketPriority, TicketStatus } from "@signalist/shared-types";

/** Every filter `GET tickets/admin` accepts (`StaffTicketPageOptionsDTO`); page and limit always go. */
export interface GetStaffTicketsArg {
	page: number;
	limit: number;
	status?: TicketStatus[];
	assigneeUserId?: number;
	/** The Unassigned tab; the API lets it win over `assigneeUserId`. */
	unassigned?: boolean;
	category?: TicketCategory;
	priority?: TicketPriority;
	companyId?: number;
	search?: string;
}

export type StaffTicketParams = Record<string, string | number>;

/**
 * The query string of the queue request. Statuses travel comma-separated (the DTO accepts both
 * forms; the comma keeps the cache key stable), `unassigned` only when true, everything else only
 * when set — an absent key must never reach the URL as "undefined".
 */
export const toStaffTicketParams = (arg: GetStaffTicketsArg): StaffTicketParams => {
	const search = arg.search?.trim();

	return {
		page: arg.page,
		limit: arg.limit,
		...(arg.status?.length ? { status: arg.status.join(",") } : {}),
		...(arg.assigneeUserId ? { assigneeUserId: arg.assigneeUserId } : {}),
		...(arg.unassigned ? { unassigned: "true" } : {}),
		...(arg.category ? { category: arg.category } : {}),
		...(arg.priority ? { priority: arg.priority } : {}),
		...(arg.companyId ? { companyId: arg.companyId } : {}),
		...(search ? { search } : {}),
	};
};
